<div class="flex flex-col">
	<div class="pt-8 pl-72 pr-72 pb-8">
		<app-breadcrumb [items]="breadcrumbItems" class="breadcrumb"></app-breadcrumb>
	</div>
    <div class="bookmark" [ngClass]="{'dr-in-progress': (showDRBanner$ | async)}">
      <img class="tag" src="/assets/images/tag.svg" />
      <span class="mat-body fs-12 fw-500 tag-text">{{'TENANT_CONTINUOUS_UPDATE.CONTINUOUS_UPDATE' | transloco}}</span>
    </div>

	<div class="flex flex-row justify-between mb-24 header-section">
		<div class="flex flex-row flex-auto pl-72 pt-12 pr-72 pb-20">
			<div class="flex flex-row items-center pt-6">
				<mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" (click)="goToTenant()"></mat-icon>
			</div>
			<div class="flex flex-col flex-auto justify-between pl-24">
				<div class="flex flex-row justify-between mb-12 instance-name">
					<div *ngIf="blueprint?.name; else headerLoader" class="mat-subtitle-1 fw-600 fs-20 mb-0">{{
						blueprint?.name }}</div>
				</div>
				<div class="flex justify-between">
					<div class="flex flex-row sub-header items-center mt--4">
						<div *ngIf="solution?.name; else loader" class="pr-16 flex items-center">{{solution?.name}}</div>
						<ng-template #loader>
							<div class="pl-6 skeleton-loader pr-16">
								<ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
							</div>
						</ng-template>
						<ng-template #headerLoader>
							<div class="pl-6 skeleton-loader-header">
								<ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
							</div>
						</ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>

	@if(hideOldView) {
		<div class="pl-72 pr-72 pb-20">
			@if(!isInsSelectionLoaded) {
				@for (item of [1,2,3]; track item) {
					<div class="w-100-percent">
						<div class="instance-card instances-group flex flex-col mt-20 mb-8 p-28">
							<ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
							<div class="flex flex-row pt-24">
								@for (subItem  of [1,2,3]; track subItem) {
									<ngx-skeleton-loader class="loader-line mr-50" count="1" appearance="line"></ngx-skeleton-loader>
								}
							</div>
						</div>
					</div>
				}
			}
			@if(!transientEnvironmentComponent && !isLoading) {
				<div class="flex flex-row justify-between">
					<div class="mat-subtitle-1 fw-600 fs-20 mb-0">{{'INSTANCE_SUMMARY.ENVIRONMENTS' | transloco}}</div>
					<button class="btn-link pb-0 mat-headline-6 fw-700 fs-16 flex flex-row p-4 justify-end items-center refresh-icon" (click)="refreshClick();">
						<mat-icon svgIcon="refresh" [@rotate]="countCU" (@rotate.done)="isRefreshing && countCU=countCU+1"></mat-icon>
					</button>
				</div>
				@if(classEInstances?.length > 0) {
					<div class="mat-subtitle-1 fs-20 fw-600 mb-16">{{'BLUEPRINT_SUMMARY.CLASS_E_ENVIRONMENT' | transloco}}</div>
					<div class="environment-border mb-24">
						@for (instance of classEInstances; track instance; let i = $index; let last = $last) {
							<ng-container [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}"></ng-container>
							@if (!last) { <mat-divider class="neutral-2 ml-10 mr-10"></mat-divider> }
						}
					</div>
				}
				@if(devInstance?.length > 0) {
					<div class="mat-subtitle-1 fs-20 fw-600 mb-16">{{'BLUEPRINT_SUMMARY.DEVELOPMENT' | transloco}}</div>
					<div class="environment-border mb-24">
						@for (instance of devInstance; track instance; let i = $index; let last = $last) {
							<ng-container [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}"></ng-container>
							@if (!last) { <mat-divider class="neutral-2 ml-10 mr-10"></mat-divider> }
						}
					</div>
				}
				@if(testDataZoneInstances?.length > 0 || piiDataZoneInstances?.length > 0) {
					<div class="mat-subtitle-1 fs-20 fw-600 mb-16">{{'TENANT_CONTINUOUS_UPDATE.PATH_TO_LIVE' | transloco}}</div>
					<div class="environment-border mb-24">
						@for (instance of testDataZoneInstances; track instance; let i = $index; let last = $last) {
							@if(instance?.id) { 
								<ng-container [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}"></ng-container>
								@if (!last) { <mat-divider class="neutral-2 ml-10 mr-10"></mat-divider> }
							}
						}
						@if (testDataZoneInstances?.length > 0 && piiDataZoneInstances?.length > 0) { <mat-divider class="neutral-2 ml-10 mr-10"></mat-divider> }
						@for (instance of piiDataZoneInstances; track instance; let i = $index; let last = $last) {
							@if(instance?.id) { 
								<ng-container [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}"></ng-container>
								@if (!last) { <mat-divider class="neutral-2 ml-10 mr-10"></mat-divider> }
							}
						}
					</div>
				}
				@if(otherInstance?.length > 0) {
					<div class="mat-subtitle-1 fs-20 fw-600 mb-16">{{'TENANT_CONTINUOUS_UPDATE.NON_PATH_TO_LIVE' | transloco}}</div>
					<div class="environment-border mb-24">
						@for (instance of otherInstance; track instance; let i = $index; let last = $last) {
							<ng-container [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}"></ng-container>
							@if (!last) { <mat-divider class="neutral-2 ml-10 mr-10"></mat-divider> }
						}
					</div>
				}
				<ng-template #instanceCard let-instance="instance">
					<div class="environment_header">
						<div class="flex flex-row">
							<div class="env-width flex flex-row items-center">
								@if(instance?.status !== DeployStatus.NOT_DEPLOYED || (instance?.environment === PathToLiveEnvironment.PREPROD || instance?.environment === PathToLiveEnvironment.LIVE)){
									<div class="flex flex-row justify-center pl-4 pr-4 width-fit" [ngClass]="instance?.dataZone !== DataZone.LIVE ? instance?.dataZone === DataZone.DEVELOPMENT ? ['nonpii-section', 'mr-12'] : ['pii-section', 'mr-12'] : ['live-section', 'mr-12']">
										<div class="width-fit fw-500 fs-12">{{('TENANT_LIST.DATAZONE'| transloco)}}&nbsp;{{instance?.dataZone === DataZone.LIVE ? ('TENANT_LIST.LIVE'| transloco) : instance?.dataZone === DataZone.DEVELOPMENT ? ('TENANT_LIST.NON_PII_SMALL'| transloco) : ('TENANT_LIST.PII'| transloco) }}</div>
									</div>
								}
								<div class="width-fit fw-500 fs-12 mr-12 class-section pl-4 pr-4">{{('TENANT_LIST.CLASS'|transloco)}}&nbsp;{{instance.deploymentClass}}</div>
								<div class="flex flex-row justify-center pl-4 pr-4 width-fit" [ngClass]="[instance?.environment === PathToLiveEnvironment.LIVE ? 'live-section' : instance?.environment === PathToLiveEnvironment.PREPROD ? 'preprod-section' : instance?.environment?.toLowerCase() === 'sit' ? 'sit-section' : instance?.type === InstanceType.OTHER ? 'other-section' : (instance?.dataZone === DataZone.DEVELOPMENT || instance?.type === InstanceType.EAAS) ? 'color-dev'  : 'color-grey']">
									<div class="width-fit fw-500 fs-12">{{ instance.deploymentClass === DeploymentClass.D ? 'DEV' : (instance?.type === InstanceType.OTHER || instance?.type === InstanceType.EAAS) ? instance?.type?.toUpperCase() : instance?.environment?.toUpperCase() }}</div>
								</div>
							</div>
							<div class="instance-header fw-400 fs-14" [ngClass]="{'visible': hoveredInstance === (instance.id ?? instance.name)}">
								<ul class="flex flex-row items-center w-100-percent pl-0">
									<li class="env-name">{{'INSTANCE_DETAILS.INSTANCE_NAME' | transloco}}</li>
									<li class="env-release-version">{{'INSTANCE_DETAILS.RELEASE_VERSION' | transloco}}</li>
									<li class="env-infra">{{'INSTANCE_DETAILS.INFRA_VERSION' | transloco}}</li>
									<li class="env-package">{{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco}}</li>
								</ul>
							</div>
							@if(instance?.availabilityState && instance?.status !== DeployStatus.NOT_DEPLOYED){
								<div class="flex flex-row items-center justify-center availableState mr-40 ml-auto" [ngClass]="instance?.availabilityState?.toLowerCase()">
									<mat-icon [svgIcon]="availableStateIcon[instance?.availabilityState?.toLowerCase()]" class="icon-sm"></mat-icon>
									{{ instance?.availabilityState | formatText | titlecase}}
								</div>
							}
						</div>
						<div class="flex flex-col cursor-pointer" (mouseenter)="mouseOver(instance)" (mouseleave)="mouseOut(instance)">
							<div class="flex flex-row pt-6 pb-8 mt-6 instance-card instances-group table-width" 
							[ngClass]="{'has-progress-banner': envProgressStatus.includes(instance?.status) && instance?.lastOperation?.executionPhase !== DeployStatus.ABORTING}">
								<div class="flex flex-row basis-full items-center instance-details items-baseline">
									<div class="flex flex-row items-center mt-1 table-width" [ngClass]="{'apply-opacity' : !hasReadPermission(instance)}">
										@if(hasReadPermission(instance)) {
											<div class="env-value flex justify-start fw-500 fs-16 pl-24 w-instance mr-12 ml-26 instance-flex" (click)="openInstanceDetails(instance)">
												{{instance?.name}}
												@if(instance?.name === 'Demo Instance'){
													<mat-icon svgIcon="info" class="icon-md-1 pl-8 icon" matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
												}
											</div>
										} @else {
											<div class="env-value w-instance pt-8 pr-16 pb-8 pl-16 mr-12 remove-opacity">
												<span class="flex flex-row cell-data instance-name fw-500 red">
													<mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon"></mat-icon>
													{{'INSTANCE_DETAILS.UNAUTHORIZED' | transloco }}
												</span>
											</div>
										}
										<div class="env-value flex flex-row justify-center items-center release-package instance-flex ws-nowrap mr-12 w-version fw-500 fs-16 warn pt-8 pr-16 pb-8 pl-16 ml-12" [title]="instance?.releaseVersion ? instance?.releaseVersion : '-'"> 
											{{ instance?.releaseVersion ? instance?.releaseVersion : '-' }}
											@if(solutionVersionsService.releaseVersion(instance?.releaseVersion)) {
												<div class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">{{('INSTANCE_DETAILS.AMR' | transloco)}}</div>
											}
										</div>
										<div [title]="instance?.infraSolutionVersion" class="env-value flex flex-row justify-center items-center ml-12 mr-12 w-version instance-flex warn">
											{{ instance?.infraSolutionVersion ? instance?.infraSolutionVersion : '-' }}
										</div>
										<div class="env-value flex flex-row instance-flex warn w-package fw-500 fs-16 pt-8 pr-16 pb-8 pl-16 mr-12 ml-12">
											<span [title]="instance?.externalPackage?.name ? instance?.externalPackage?.name : '-'" class="status-button">
												{{instance?.externalPackage?.name ? instance?.externalPackage?.name : '-' }}
											</span>
											@if(instance?.externalPackage?.name) {
												<span (click)="customPackageClick(instance)"><mat-icon svgIcon="info" class="icon-sm ml-4 cursor-pointer"></mat-icon></span>
											}
										</div>
										<div class="flex flex-row justify-end items-center ml-auto">
											<div [title]="instance?.status" class="mr-12 ml-12">
												<span [ngClass]="instance?.lastOperation?.executionPhase === DeployStatus.ABORTING ? DeployStatus.ABORTING : instance?.status" class="pt-4 pr-8 pb-4 pl-8 flex flex-row items-center gap-1">
													@if(envProgressStatus.includes(instance?.status)) {
														<mat-spinner diameter="16" class="progress-color" mode="indeterminate"></mat-spinner>
													} @else if (environmentStatusIcon[instance?.status]) {
														<mat-icon [svgIcon]="environmentStatusIcon[instance?.status]" class="icon-sm"></mat-icon>
													}
													<span class="status-button" [title]="instance.status">{{(instance?.lastOperation?.executionPhase === DeployStatus.ABORTING ? instance?.lastOperation?.executionPhase + ' ' + instance?.lastOperation?.type : instance.status) | titlecase}}</span>
												</span>
											</div>
											<div class="rounded ml-12 accent flex items-center mr-26" [ngClass]="{'apply-opacity' : !hasUpdatePermission(instance)}">
												@if(UPDATE_ALLOWED_STATUS.includes(instance?.status) && instance?.deploymentClass !== DeploymentClass.E) {
													<button [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING) : (instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING)}" class="accent pt-4 pr-12 pb-4 pl-12 h-32 fw-600 flex items-center" type="button" [matMenuTriggerFor]="(hasUpdatePermission(instance) ? blueprintVersionMenu : '')" (menuOpened)="onInstanceMenuOpened()">
														{{'BUTTONS.UPDATE' | transloco}}
														<mat-icon svgIcon="expand_more" class="flex justify-end icon-sm ml-8"></mat-icon>
													</button>
												}
												@if(!hasUpdatePermission(instance)) {
													<div class="add-lock flex red">
														@if(UPDATE_ALLOWED_STATUS.includes(instance?.status)) {
															<mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
														}
													</div>
												}
												<mat-menu #blueprintVersionMenu [xPosition]="'before'" class="context-menu-dropdown">
													<button class="flex justify-start items-center action-button h-40 pl-16"
														[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
														(click)="updateBuild(instance)">
														<div class="fw-500 menu-button">
															{{'INSTANCE_DETAILS.SOLUTION_UPGRADE' | transloco}}
														</div>
													</button>
													@if(hasUpdatePermission(instance) && instance?.type !== 'tsi' && instance?.type !== 'tss'){
													<button class="flex justify-start items-center action-button h-40 pl-16"
														[ngClass]="{'disabled': (instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING), 'disable-infra': !instance?.isInfraUpgrade }"
														(click)="instance?.isInfraUpgrade ? infraUpgradeClick(instance) : ''"
														[disabled]="!instance?.isInfraUpgrade"
														matTooltipClass="left infra-tooltip" matTooltipPosition="left" [matTooltip]="instance?.isInfraUpgrade ? '' : ('INSTANCE_DETAILS.INFRA_UPGRADE_DISABLE' | transloco)">
														<div class="fw-500 menu-button">{{'INSTANCE_DETAILS.INFRA_UPGRADE' |
															transloco}}</div>
													</button>
													}
													@if(instance?.type !== 'tsi' && instance?.type !== 'tss') {

													<button class="flex justify-start items-center action-button h-40 pl-16"
														[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
														(click)="packageUpdate(instance)">
														<div class="fw-500 menu-button">{{'INSTANCE_DETAILS.CUSTOM_PACKAGE' |
															transloco}}</div>
													</button>
													}
													@if(showComponentUpdate) {
													<button class="flex justify-start items-center action-button h-40 pl-16"
														[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
														(click)="componentUpdate(instance)">
														<div class="fw-500 menu-button">{{'INSTANCE_DETAILS.COMPONENT_UPDATE' |
															transloco}}</div>
													</button>
													}
													@if (instance?.type !== 'tsi' && instance?.type !== 'tss' && canAccessBaseImageFeature(instance?.id)) {
													<button class="flex justify-start items-center action-button h-40 pl-16" [ngClass]="{'disabled': instance?.status === DeployStatus.UPDATING }" (click)="baseImageUpdate(instance)">
														<div class="fw-500 menu-button">{{'INSTANCE_DETAILS.BASE_IMAGE' | transloco}}</div>
													</button>
													}
												</mat-menu>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						@if (envProgressStatus.includes(instance?.status) && instance?.lastOperation?.executionPhase !== DeployStatus.ABORTING)
						{
						<div class="flex flex-row justify-center items-center instance-info-line mb--2 warn-bg">
							<mat-spinner diameter="24" class="w-24 h-24 mr-8"></mat-spinner>
							{{ (instance?.status === DeployStatus.INPROGRESS &&
							activityProgressService.getEnvironmentStatus(instance?.lastOperation?.type, instance?.status))
							? (activityProgressService.getEnvironmentStatus(instance?.lastOperation?.type, instance?.status) | transloco)
							: (instance.status | titlecase) }}
							<mat-progress-bar class="mt-2 ml-16 mr-8 w-160 progress" mode="indeterminate"></mat-progress-bar>
							@if (INSTANCE_DEPLOYING_STATES_COUNT.includes(instance?.status) && instance?.status !== DeployStatus.TERMINATED &&
							instance?.activityDetails?.countData?.total) {
							<span class="progress-value ml-16 mr-8">{{instance?.activityDetails?.countData?.completedPercent}}%</span>
							<span class="progress-value mr-8">{{ 'ACTIVITY_DETAILS.COMPLETE' | transloco }}</span>
							}
							@if (activityProgressService.getTimeRemaining(toUtcString(instance?.activityStartTime),
							instance?.expectedDurationMs, currentTime); as timeLeft) {
							<mat-icon svgIcon="schedule" class="icon-sm ml-12 mr-4"></mat-icon>
							<span class="time-remaining fs-14 fw-400 mr-4">{{ 'ACTIVITY_DETAILS.EST_TIME_LEFT' | transloco }}</span>
							<span class="time-remaining fs-14 fw-600 mr-12">{{ timeLeft }}</span>
							}
							<div class="view-link cursor-pointer" (click)="openActivityDetails(instance)">View</div>
						</div>
						}
					</div>
				</ng-template>
			}
		</div>
	}
	  <ng-container *ngIf="!isInsSelectionLoaded && !hideOldView">
		<div class="mat-subtitle-1 fw-600 fs-20 mt-16 mb-16">{{'INSTANCE_SUMMARY.INSTANCES' | transloco}}</div>
		<div class="pl-72 pr-72">
		  <div class="instances-group loader-header loader-section mb-8 flex flex-col p-16">
			<div class="flex flex-row">
			  <ng-container *ngFor="let item of [1,2,3,4,5,6]">
				<div class="loader-style">
				  <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
				</div>
			  </ng-container>
			</div>
		  </div>
		  <div *ngFor="let item of [1,2,3]" class="w-100-percent loader-section mb-8">
			<div class="instances-group flex flex-col p-16">
				<div class="flex flex-row">
				  <ng-container *ngFor="let item of [1,2,3,4,5,6]">
					<div class="loader-style">
					  <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
					</div>
				  </ng-container>
				</div>
			</div>
		  </div>
		</div>
	</ng-container>
	<div *ngIf="instances?.length === 0 && classEInstances?.length === 0 && !showSpinner" class="flex flex-col items-center fw-600 fs-20 justify-center pt-48 pb-48">
		<img src="/assets/images/unavailable-instance.png">
		{{'INSTANCE_LIST.INSTANCE_UNAVAILABLE' | transloco }}
	</div>

	<div *ngIf="!transientEnvironmentComponent && !isLoading && !hideOldView">
		<div class="flex flex-row justify-between items-end pt-6 mb-24">
			<div class="mat-subtitle-1 fw-700 fs-24 mb-0">{{'INSTANCE_SUMMARY.ENVIRONMENTS' | transloco}}</div>

			<!-- <div class="flex justify-end">
				<button *ngIf="!viewTransient" class="flex  items-center run-test mr-24" type="button" [ngClass]="{'disabled': runTest || instances?.length === 0 && !showSpinner && !isFailed}" (click)="runTesting()">
					<mat-icon svgIcon="play_arrow"></mat-icon>
					<span class="pl-10 fw-400 fs-16">{{'CONTINUOUS_UPDATES.RUN_TEST' | transloco}}</span>
				</button>
				<button *ngIf="viewTransient" class="flex  items-center run-test mr-24 view-button" type="button" [ngClass]="{'disabled': runTest || instances?.length === 0 && !showSpinner && !isFailed}" (click)="viewTesting()">
					<mat-icon svgIcon="play_arrow"></mat-icon>
					<span class="pl-10 fw-400 fs-16">{{'CONTINUOUS_UPDATES.VIEW_TEST' | transloco}}</span>
				</button>
				<button class="flex  items-center accent reject-update" type="button" (click)="rejectUpdate()">
					<mat-icon svgIcon="do_not_disturb_alt"></mat-icon>
					<span class="pl-10">{{'INSTANCE_DETAILS.REJECT_UPDATE' | transloco}}</span>
				</button>
			</div> -->
		</div>
    <div *ngIf="devInstance?.length > 0" class="mat-subtitle-1 fs-22 fw-600 mb-16 mt-28">{{'BLUEPRINT_SUMMARY.DEVELOPMENT_ENVIRONMENT' | transloco }}</div>
    <div *ngIf="devInstance?.length > 0" class="view-instances environment-header">
      <div class="tbl tbl-shared-instances w-100-percent">
        <div class="tbl-header-row primary mb-8 fw-700 fs-14 mat-subtitle-2">
          <div class="tbl-cell col-instance-name pl-12">{{ 'INSTANCE_DETAILS.INSTANCE_NAME' | transloco | uppercase}}</div>

          <div class="tbl-cell col-primary">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco | uppercase }}</div>
          <!-- <div class="tbl-cell col-secondary cursor-pointer">
            {{ 'INSTANCE_DETAILS.BUILD_VERSION' | transloco | uppercase }}
          </div> -->
          <div class="tbl-cell col-class cursor-pointer">
            {{ 'INSTANCE_DETAILS.RELEASE_VERSION' | transloco | uppercase }}
          </div>
		  <div class="tbl-cell col-infra cursor-pointer">
            {{ 'INSTANCE_DETAILS.INFRA_VERSION' | transloco | uppercase }}
          </div>
          <div class="tbl-cell col-secondary cursor-pointer">
            {{ 'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco | uppercase }}
          </div>
          <div class="tbl-cell col-status cursor-pointer">
            {{ 'INSTANCE_DETAILS.STATUS' | transloco | uppercase }}
          </div>
          <div class="tbl-cell col-action items-center">{{ 'INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_BUILD' | transloco | uppercase }}</div>
        </div>
        <div class="tbl-body">
          <div *ngFor="let instance of devInstance" class="mb-8">
            <div class="tbl-body-row tbl-high-row fw-400 fs-16 mat-subtitle-2" [ngClass]="{'apply-opacity' : !permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]}">
              <div *ngIf="permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]; else showUnauthorized" class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border" (click)="openInstanceDetails(instance)">
                <span class="cell-data instance-name fw-500 clickable" [title]="instance?.name">{{instance?.name}}</span>
                <mat-icon *ngIf="instance?.name === 'Demo Instance'" svgIcon="info" class="icon-md-1 pl-8 icon"
                matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
              </div>
			  <ng-template #showUnauthorized>
				<div class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border remove-opacity">
					<span class="flex flex-row cell-data instance-name fw-500 red">
						<mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon"></mat-icon>
						{{ 'INSTANCE_DETAILS.UNAUTHORIZED' | transloco }}</span>
				</div>
			</ng-template>
              <div class="tbl-cell col-primary cell-data border fs-14 fw-500" [title]="instance?.dataZone">
                {{ instance?.dataZone | titlecase }}
              </div>
              <!-- <div class="tbl-cell col-secondary border mat-body-1" [title]="instance?.version ? instance?.version : '-'">
                {{ instance?.version ? instance?.version : '-' }}
              </div> -->
              <div class="tbl-cell col-class border mat-body-1 flex items-center" [title]="instance?.releaseVersion ? instance?.releaseVersion : '-'">
                {{ instance?.releaseVersion ? instance?.releaseVersion : '-' }}
                <div *ngIf="solutionVersionsService.releaseVersion(instance?.releaseVersion)" class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">
                  {{('INSTANCE_DETAILS.AMR' | transloco)}}
                </div>
              </div>
			  <div class="tbl-cell col-infra border mat-body-1 flex items-center" [title]="instance?.infraSolutionVersion">
                {{ instance?.infraSolutionVersion ? instance?.infraSolutionVersion : '-' }}
              </div>
              <div class="tbl-cell col-secondary flex items-center border mat-body-1">
                <span [title]="instance?.externalPackage?.name ? instance?.externalPackage?.name : '-'" class="custom-package">{{ instance?.externalPackage?.name ? instance?.externalPackage?.name : '-' }}</span>
                <span *ngIf="instance?.externalPackage?.name" (click)="customPackageClick(instance)"><mat-icon svgIcon="info" class="icon-sm ml-4 cursor-pointer"></mat-icon></span>
              </div>
              <div class="tbl-cell col-status fs-16 fw-400 border mat-body-1" [title]="instance?.status">
                  <span [ngClass]="{'failed': failedStatus.includes(instance?.status),
                    'updated': updatedStatus.includes(instance?.status),
                    'pending': pendingStatus.includes(instance?.status),
                    'in-progress': inProgressStatus.includes(instance?.status) || instance?.lastOperation?.executionPhase === DeployStatus.ABORTING}"
                    class="pt-4 pr-8 pb-4 pl-8 flex">
					<mat-icon *ngIf="statusIcons[instance?.status]" [svgIcon]="statusIcons[instance?.status]" class="icon-sm mr-4 mt-4" [ngClass]="instance?.status === DeployStatus.DEPLOYED || instance?.status === DeployStatus.UPDATED ? 'sucess-circle': 'failed-circle'"></mat-icon>
					{{ (instance?.lastOperation?.executionPhase === DeployStatus.ABORTING ? instance?.lastOperation?.executionPhase + ' ' + instance?.lastOperation?.type : instance?.status) | titlecase}}
                    <mat-progress-bar *ngIf="instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.INITIALIZING || instance?.status === DeployStatus.DEPLOYING" class="progress-bar" mode="indeterminate"></mat-progress-bar>
                  </span>
              </div>
              <div class="tbl-cell col-action" [ngClass]="{'apply-opacity' : !permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]}">
                <button *ngIf="(instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
                  instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED || instance?.status === DeployStatus.STOP_FAILED) && instance?.deploymentClass !== DeploymentClass.E"
                  [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING) : (instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING), 'background-color-opacity': !permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]}"
				  class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600 flex items-center"
                  type="button" [matMenuTriggerFor]="(permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] ? blueprintVersionMenu : '')">
                    {{'BUTTONS.UPDATE' | transloco}}<mat-icon svgIcon="expand_more" class="flex justify-end icon-sm ml-8"></mat-icon>
                </button>
				<div *ngIf="!permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]" class="add-lock flex red">
					<mat-icon *ngIf="instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
					instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED" svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
				</div>
				<mat-menu #blueprintVersionMenu [xPosition]="'before'" class="context-menu-dropdown">					
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
						(click)="updateBuild(instance)">
						<div class="fw-500 menu-button">
						  {{'INSTANCE_DETAILS.SOLUTION_UPGRADE' | transloco}}
						</div>
					</button>
					@if(permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] && instance?.type !== 'tsi' && instance?.type !== 'tss'){
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': (instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING), 'disable-infra': !instance?.isInfraUpgrade }"
						(click)="instance?.isInfraUpgrade ? infraUpgradeClick(instance) : ''"
						[disabled]="!instance?.isInfraUpgrade"
						matTooltipClass="left infra-tooltip" matTooltipPosition="left" [matTooltip]="instance?.isInfraUpgrade ? '' : ('INSTANCE_DETAILS.INFRA_UPGRADE_DISABLE' | transloco)">
						<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.INFRA_UPGRADE' | transloco}}
						</div>
					</button>
					}
					<button class="flex justify-start items-center action-button h-40 pl-16"
					[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="packageUpdate(instance)">
						<div class="fw-500 menu-button">
						  {{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco}}
						</div>
					</button>
					@if(showComponentUpdate) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="componentUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.COMPONENT_UPDATE' | transloco}}
							</div>
						</button>
					}
					@if(canAccessBaseImageFeature(instance?.id)) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.status === DeployStatus.UPDATING }" (click)="baseImageUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.BASE_IMAGE' | transloco}}
							</div>
						</button>
					}
				</mat-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="testDataZoneInstances?.length > 0 || piiDataZoneInstances?.length > 0" class="mat-subtitle-1 fs-22 fw-600 mb-16">{{'TENANT_CONTINUOUS_UPDATE.PATH_TO_LIVE' | transloco }}</div>
	<div *ngIf="testDataZoneInstances?.length > 0 || piiDataZoneInstances?.length > 0" class="environment-header">
    <div *ngIf="testDataZoneInstances?.length > 0" class="mat-subtitle-1 fs-10 fw-700 test-zone mb-0 pl-16">{{'TENANT_CONTINUOUS_UPDATE.TEST_DATA_ZONE' | transloco | uppercase}}</div>
    <div class="view-instances">
      <div class="tbl tbl-shared-instances w-100-percent">
		<div *ngIf="testDataZoneInstances?.length > 0 && devInstance?.length === 0" class="tbl-header-row primary mb-8 fw-700 fs-14 mat-subtitle-2">
			<div class="tbl-cell col-instance-name pl-12">{{ 'INSTANCE_DETAILS.INSTANCE_NAME' | transloco | uppercase}}</div>
			<div class="tbl-cell col-primary">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco | uppercase }}</div>
			<!-- <div class="tbl-cell col-secondary cursor-pointer">
			  {{ 'INSTANCE_DETAILS.BUILD_VERSION' | transloco | uppercase }}
			</div> -->
			<div class="tbl-cell col-class cursor-pointer">
			  {{ 'INSTANCE_DETAILS.RELEASE_VERSION' | transloco | uppercase }}
			</div>
			<div class="tbl-cell col-infra cursor-pointer">
			  {{ 'INSTANCE_DETAILS.INFRA_VERSION' | transloco | uppercase }}
			</div>
            <div class="tbl-cell col-secondary cursor-pointer">
              {{ 'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco | uppercase }}
            </div>
			<div class="tbl-cell col-status cursor-pointer">
			  {{ 'INSTANCE_DETAILS.STATUS' | transloco | uppercase }}
			</div>
			<div class="tbl-cell col-action items-center">{{ 'INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_BUILD' | transloco | uppercase }}</div>
		  </div>
        <div class="tbl-body">
          <div *ngFor="let instance of testDataZoneInstances" class="mb-8">
            <ng-container *ngIf="instance?.id">
              <div class="tbl-body-row tbl-high-row fw-400 fs-16 mat-subtitle-2" [ngClass]="{'apply-opacity' : !permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]}">
                <div *ngIf="permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]; else showUnauthorized" class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border" (click)="openInstanceDetails(instance)">
                  <span class="cell-data instance-name fw-500 clickable" [title]="instance?.name">{{instance?.name}}</span>
                  <mat-icon *ngIf="instance?.name === 'Demo Instance'" svgIcon="info" class="icon-md-1 pl-8 icon"
                  matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
                </div>
				<ng-template #showUnauthorized>
					<div class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border remove-opacity">
						<span class="flex flex-row cell-data instance-name fw-500 red">
							<mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon"></mat-icon>
							{{ 'INSTANCE_DETAILS.UNAUTHORIZED' | transloco }}</span>
					</div>
				</ng-template>
                <div class="tbl-cell col-primary cell-data border fs-14 fw-500" [title]="instance?.dataZone">
                  {{ instance?.dataZone | titlecase }}
                </div>
                <!-- <div class="tbl-cell col-secondary border mat-body-1" [title]="instance?.version ? instance?.version : '-'">
                  {{ instance?.version ? instance?.version : '-' }}
                </div> -->
                <div class="tbl-cell col-class border mat-body-1 flex items-center" [title]="instance?.releaseVersion ? instance?.releaseVersion : '-'">
                  {{ instance?.releaseVersion ? instance?.releaseVersion : '-' }}
				  <div *ngIf="solutionVersionsService.releaseVersion(instance?.releaseVersion)" class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">
					{{('INSTANCE_DETAILS.AMR' | transloco)}}
				  </div>
                </div>
				<div class="tbl-cell col-infra border mat-body-1 flex items-center" [title]="instance?.infraSolutionVersion">
                  {{ instance?.infraSolutionVersion ? instance?.infraSolutionVersion : '-' }}
                </div>
                <div class="tbl-cell col-secondary flex items-center border mat-body-1">
                    <span [title]="instance?.externalPackage?.name ? instance?.externalPackage?.name : '-'" class="custom-package">{{ instance?.externalPackage?.name ? instance?.externalPackage?.name : '-' }}</span>
                    <span *ngIf="instance?.externalPackage?.name" (click)="customPackageClick(instance)"><mat-icon svgIcon="info" class="icon-sm ml-4 cursor-pointer"></mat-icon></span>
                </div>
                <div class="tbl-cell col-status border mat-body-1" [title]="instance?.status">
                    <span [ngClass]="{'failed': failedStatus.includes(instance?.status),
                      'updated': updatedStatus.includes(instance?.status),
                      'pending': pendingStatus.includes(instance?.status),
                      'in-progress': inProgressStatus.includes(instance?.status)}"
                      class="pt-4 pr-8 pb-4 pl-8 flex">
					  <mat-icon *ngIf="statusIcons[instance?.status]" [svgIcon]="statusIcons[instance?.status]" class="icon-sm mr-4 mt-4" [ngClass]="instance?.status === DeployStatus.DEPLOYED || instance?.status === DeployStatus.UPDATED ? 'sucess-circle': 'failed-circle'"></mat-icon>
					{{formatAvailabilityState(instance?.status) | titlecase}}
                      <mat-progress-bar *ngIf="instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.DEPLOYING" class="progress-bar" mode="indeterminate"></mat-progress-bar>
                    </span>
                </div>
                <div class="tbl-cell col-action" [ngClass]="{'apply-opacity' : !permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]}">
                  <button *ngIf="(instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
                  	instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED || instance?.status === DeployStatus.STOP_FAILED) && instance?.deploymentClass !== DeploymentClass.E"
                    [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING) : (instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING), 'background-color-opacity': !permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]}"
                    class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600 flex items-center"
                  	type="button" [matMenuTriggerFor]="(permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] ? blueprintVersionMenu : '')">
                    	{{'BUTTONS.UPDATE' | transloco}}<mat-icon svgIcon="expand_more" class="flex justify-end icon-sm ml-8"></mat-icon>
                 </button>
				 <div *ngIf="!permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]" class="add-lock flex red">
					<mat-icon *ngIf="instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
					instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED" svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
				</div>
				 <mat-menu #blueprintVersionMenu [xPosition]="'before'" class="context-menu-dropdown">
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
						(click)="updateBuild(instance)">
						<div class="fw-500 menu-button">
						  {{'INSTANCE_DETAILS.SOLUTION_UPGRADE' | transloco}}
						</div>
					</button>
					@if(permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] && instance?.type !== 'tsi' && instance?.type !== 'tss') {
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': (instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING), 'disable-infra': !instance?.isInfraUpgrade }"
						(click)="instance?.isInfraUpgrade ? infraUpgradeClick(instance) : ''"
						[disabled]="!instance?.isInfraUpgrade"
						matTooltipClass="left infra-tooltip" matTooltipPosition="left" [matTooltip]="instance?.isInfraUpgrade ? '' : ('INSTANCE_DETAILS.INFRA_UPGRADE_DISABLE' | transloco)">
						<div class="fw-500 menu-button">
						  {{'INSTANCE_DETAILS.INFRA_UPGRADE' | transloco}}
						</div>
					</button>
					}
					<button class="flex justify-start items-center action-button h-40 pl-16"
					[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="packageUpdate(instance)">
						<div class="fw-500 menu-button">
						  {{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco}}
						</div>
					</button>
					@if(showComponentUpdate) {
					<button class="flex justify-start items-center action-button h-40 pl-16"
					[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="componentUpdate(instance)">
						<div class="fw-500 menu-button">
						  {{'INSTANCE_DETAILS.COMPONENT_UPDATE' | transloco}}
						</div>
					</button>
					}
					@if(canAccessBaseImageFeature(instance?.id)) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.status === DeployStatus.UPDATING }" (click)="baseImageUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.BASE_IMAGE' | transloco}}
							</div>
						</button>
					}
				  </mat-menu>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

	<div *ngIf="piiDataZoneInstances?.length > 0" class="mat-subtitle-1 fs-10 fw-700 test-zone mb-0 pl-16 pii-zone">{{'TENANT_CONTINUOUS_UPDATE.PII_DATA_ZONE' | transloco | uppercase}}</div>
    <div class="view-instances mb-32">
		<div class="tbl tbl-shared-instances w-100-percent">
			<div  *ngIf="piiDataZoneInstances?.length > 0 && devInstance?.length === 0" class="tbl-header-row primary mb-8 fw-700 fs-14 mat-subtitle-2">
				<div class="tbl-cell col-instance-name pl-12">{{ 'INSTANCE_DETAILS.INSTANCE_NAME' | transloco | uppercase}}</div>
				<div class="tbl-cell col-primary">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco | uppercase }}</div>
				<!-- <div class="tbl-cell col-secondary cursor-pointer">
				  {{ 'INSTANCE_DETAILS.BUILD_VERSION' | transloco | uppercase }}
				</div> -->
				<div class="tbl-cell col-class cursor-pointer">
				  {{ 'INSTANCE_DETAILS.RELEASE_VERSION' | transloco | uppercase }}
				</div>
				<div class="tbl-cell col-infra cursor-pointer">
				  {{ 'INSTANCE_DETAILS.INFRA_VERSION' | transloco | uppercase }}
				</div>
                <div class="tbl-cell col-secondary cursor-pointer">
                  {{ 'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco | uppercase }}
                </div>
				<div class="tbl-cell col-status cursor-pointer">
				  {{ 'INSTANCE_DETAILS.STATUS' | transloco | uppercase }}
				</div>
				<div class="tbl-cell col-action items-center">{{ 'INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_BUILD' | transloco | uppercase }}</div>
			  </div>
        <div class="tbl-body">
          <div *ngFor="let instance of piiDataZoneInstances" class="mb-8">
            <ng-container *ngIf="instance?.id">
              <div class="tbl-body-row tbl-high-row fw-400 fs-16 mat-subtitle-2" [ngClass]="{'apply-opacity' : !((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE]))}">
                <div *ngIf="((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE])); else showUnauthorized" class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border" (click)="openInstanceDetails(instance)">
                  <span class="cell-data instance-name fw-500 clickable" [title]="instance?.name">{{instance?.name}}</span>
                  <mat-icon *ngIf="instance?.name === 'Demo Instance'" svgIcon="info" class="icon-md-1 pl-8 icon"
                  matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
                </div>
				<ng-template #showUnauthorized>
					<div class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border remove-opacity">
						<span class="flex flex-row cell-data instance-name fw-500 red">
							<mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon"></mat-icon>
							{{ 'INSTANCE_DETAILS.UNAUTHORIZED' | transloco }}</span>
					</div>
				</ng-template>

                <div class="tbl-cell col-primary cell-data border fs-14 fw-500" [title]="instance?.dataZone">
                  {{ instance?.dataZone | titlecase }}
                </div>
                <!-- <div class="tbl-cell col-secondary border mat-body-1" [title]="instance?.version ? instance?.version : '-'">
                  {{ instance?.version ? instance?.version : '-' }}
                </div> -->
                <div class="tbl-cell col-class border mat-body-1 flex items-center" [title]="instance?.releaseVersion ? instance?.releaseVersion : '-'">
                  {{ instance?.releaseVersion ? instance?.releaseVersion : '-' }}
				  <div *ngIf="solutionVersionsService.releaseVersion(instance?.releaseVersion)" class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">
					{{('INSTANCE_DETAILS.AMR' | transloco)}}
				  </div>
                </div>
				<div class="tbl-cell col-infra mat-body-1 flex items-center border" [title]="instance?.infraSolutionVersion">
                  {{ instance?.infraSolutionVersion ? instance?.infraSolutionVersion : '-' }}
                </div>
                <div class="tbl-cell col-secondary flex items-center border mat-body-1">
                    <span [title]="instance?.externalPackage?.name ? instance?.externalPackage?.name : '-'" class="custom-package">{{ instance?.externalPackage?.name ? instance?.externalPackage?.name : '-' }}</span>
                    <span *ngIf="instance?.externalPackage?.name" (click)="customPackageClick(instance)"><mat-icon svgIcon="info" class="icon-sm ml-4 cursor-pointer"></mat-icon></span>
                </div>
                <div class="tbl-cell col-status border mat-body-1" [title]="instance?.status">
                    <span [ngClass]="{'failed': failedStatus.includes(instance?.status),
                      'updated': updatedStatus.includes(instance?.status),
                      'pending': pendingStatus.includes(instance?.status),
                      'in-progress': inProgressStatus.includes(instance?.status)}"
                      class="pt-4 pr-8 pb-4 pl-8 flex">
					  <mat-icon *ngIf="statusIcons[instance?.status]" [svgIcon]="statusIcons[instance?.status]" class="icon-sm mr-4 mt-4" [ngClass]="instance?.status === DeployStatus.DEPLOYED || instance?.status === DeployStatus.UPDATED ? 'sucess-circle': 'failed-circle'"></mat-icon>
					{{formatAvailabilityState(instance?.status) | titlecase}}
                      <mat-progress-bar *ngIf="instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.DEPLOYING" class="progress-bar" mode="indeterminate"></mat-progress-bar>
                    </span>
                </div>
                <div class="tbl-cell col-action" [ngClass]="{'apply-opacity' : !((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE]))}">
                  <button *ngIf="(instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
                  	instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED || instance?.status === DeployStatus.STOP_FAILED) && instance?.deploymentClass !== DeploymentClass.E"
                    [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING) : (instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING), 'background-color-opacity': !((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE])) }"
					class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600 flex items-center"
					type="button" [matMenuTriggerFor]="(((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE])) ? blueprintVersionMenu : '')">
						{{'BUTTONS.UPDATE' | transloco}}<mat-icon svgIcon="expand_more" class="flex justify-end icon-sm ml-8"></mat-icon>
				 </button>
				 <div *ngIf="!((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE]))" class="add-lock flex red">
					<mat-icon *ngIf="instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
					instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED" svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
				</div>
				  <mat-menu #blueprintVersionMenu [xPosition]="'before'" class="context-menu-dropdown">
					
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
						(click)="updateBuild(instance)">
						<div class="fw-500 menu-button">
						{{'INSTANCE_DETAILS.SOLUTION_UPGRADE' | transloco}}
						</div>
					</button>
					@if(((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) ||
					(instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE])) && instance?.type !== 'tsi' && instance?.type !== 'tss') {
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': (instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING), 'disable-infra': !instance?.isInfraUpgrade }"
						(click)="instance?.isInfraUpgrade ? infraUpgradeClick(instance) : ''"
						[disabled]="!instance?.isInfraUpgrade"
						matTooltipClass="left infra-tooltip" matTooltipPosition="left" [matTooltip]="instance?.isInfraUpgrade ? '' : ('INSTANCE_DETAILS.INFRA_UPGRADE_DISABLE' | transloco)">
						<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.INFRA_UPGRADE' | transloco}}
						</div>
					</button>
					}
					<button class="flex justify-start items-center action-button h-40 pl-16"
					[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="packageUpdate(instance)">
						<div class="fw-500 menu-button">
						{{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco}}
						</div>
					</button>
					@if(showComponentUpdate) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="componentUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.COMPONENT_UPDATE' | transloco}}
							</div>
						</button>
					}
					@if(canAccessBaseImageFeature(instance?.id)) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.status === DeployStatus.UPDATING }" (click)="baseImageUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.BASE_IMAGE' | transloco}}
							</div>
						</button>
					}
				  </mat-menu>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
	</div>

	<div *ngIf="nonPiiNonPTLInstances?.length > 0 " class="mat-subtitle-1 fs-22 fw-600 mb-16">{{'TENANT_CONTINUOUS_UPDATE.NON_PATH_TO_LIVE' | transloco }}</div>
	<div *ngIf="nonPiiNonPTLInstances?.length > 0 || piiNonPTLInstances?.length > 0" class="environment-header">
    <div *ngIf="nonPiiNonPTLInstances?.length > 0" class="mat-subtitle-1 fs-10 fw-700 test-zone mb-0 pl-16">{{'TENANT_CONTINUOUS_UPDATE.TEST_DATA_ZONE' | transloco | uppercase}}</div>
    <div class="view-instances">
      <div class="tbl tbl-shared-instances w-100-percent">
		<div *ngIf="nonPiiNonPTLInstances?.length > 0 && devInstance?.length === 0" class="tbl-header-row primary mb-8 fw-700 fs-14 mat-subtitle-2">
			<div class="tbl-cell col-instance-name pl-12">{{ 'INSTANCE_DETAILS.INSTANCE_NAME' | transloco | uppercase}}</div>
			<div class="tbl-cell col-primary">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco | uppercase }}</div>
			<!-- <div class="tbl-cell col-secondary cursor-pointer">
			  {{ 'INSTANCE_DETAILS.BUILD_VERSION' | transloco | uppercase }}
			</div> -->
			<div class="tbl-cell col-class cursor-pointer">
			  {{ 'INSTANCE_DETAILS.RELEASE_VERSION' | transloco | uppercase }}
			</div>
			<div class="tbl-cell col-infra cursor-pointer">
			  {{ 'INSTANCE_DETAILS.INFRA_VERSION' | transloco | uppercase }}
			</div>
            <div class="tbl-cell col-secondary cursor-pointer">
              {{ 'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco | uppercase }}
            </div>
			<div class="tbl-cell col-status cursor-pointer">
			  {{ 'INSTANCE_DETAILS.STATUS' | transloco | uppercase }}
			</div>
			<div class="tbl-cell col-action items-center">{{ 'INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_BUILD' | transloco | uppercase }}</div>
		  </div>
        <div class="tbl-body">
          <div *ngFor="let instance of nonPiiNonPTLInstances" class="mb-8">
            <ng-container *ngIf="instance?.id">
              <div class="tbl-body-row tbl-high-row fw-400 fs-16 mat-subtitle-2" [ngClass]="{'apply-opacity' : !permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]}">
                <div *ngIf="permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]; else showUnauthorized" class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border" (click)="openInstanceDetails(instance)">
                  <span class="cell-data instance-name fw-500 clickable" [title]="instance?.name">{{instance?.name}}</span>
                  <mat-icon *ngIf="instance?.name === 'Demo Instance'" svgIcon="info" class="icon-md-1 pl-8 icon"
                  matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
                </div>
				<ng-template #showUnauthorized>
					<div class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border remove-opacity">
						<span class="flex flex-row cell-data instance-name fw-500 red">
							<mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon"></mat-icon>
							{{ 'INSTANCE_DETAILS.UNAUTHORIZED' | transloco }}</span>
					</div>
				</ng-template>
                <div class="tbl-cell col-primary cell-data border fs-14 fw-500" [title]="instance?.dataZone">
                  {{ instance?.dataZone | titlecase }}
                </div>
                <!-- <div class="tbl-cell col-secondary border mat-body-1" [title]="instance?.version ? instance?.version : '-'">
                  {{ instance?.version ? instance?.version : '-' }}
                </div> -->
                <div class="tbl-cell col-class border mat-body-1 flex items-center" [title]="instance?.releaseVersion ? instance?.releaseVersion : '-'">
                  {{ instance?.releaseVersion ? instance?.releaseVersion : '-' }}
				  <div *ngIf="solutionVersionsService.releaseVersion(instance?.releaseVersion)" class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">
					{{('INSTANCE_DETAILS.AMR' | transloco)}}
				  </div>
                </div>
				<div class="tbl-cell col-infra border mat-body-1 flex items-center" [title]="instance?.infraSolutionVersion">
                  {{ instance?.infraSolutionVersion ? instance?.infraSolutionVersion : '-' }}
                </div>
                <div class="tbl-cell col-secondary flex items-center border mat-body-1">
                    <span [title]="instance?.externalPackage?.name ? instance?.externalPackage?.name : '-'" class="custom-package">{{ instance?.externalPackage?.name ? instance?.externalPackage?.name : '-' }}</span>
                    <span *ngIf="instance?.externalPackage?.name" (click)="customPackageClick(instance)"><mat-icon svgIcon="info" class="icon-sm ml-4 cursor-pointer"></mat-icon></span>
                </div>
                <div class="tbl-cell col-status border mat-body-1" [title]="instance?.status">
                    <span [ngClass]="{'failed': failedStatus.includes(instance?.status),
                      'updated': updatedStatus.includes(instance?.status),
                      'pending': pendingStatus.includes(instance?.status),
                      'in-progress': inProgressStatus.includes(instance?.status)}"
                      class="pt-4 pr-8 pb-4 pl-8 flex">
					  <mat-icon *ngIf="statusIcons[instance?.status]" [svgIcon]="statusIcons[instance?.status]" class="icon-sm mr-4 mt-4" [ngClass]="instance?.status === DeployStatus.DEPLOYED || instance?.status === DeployStatus.UPDATED ? 'sucess-circle': 'failed-circle'"></mat-icon>
					{{formatAvailabilityState(instance?.status) | titlecase}}
                      <mat-progress-bar *ngIf="instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.DEPLOYING" class="progress-bar" mode="indeterminate"></mat-progress-bar>
                    </span>
                </div>
                <div class="tbl-cell col-action" [ngClass]="{'apply-opacity' : !permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]}">
                  <button *ngIf="(instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
                  	instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED || instance?.status === DeployStatus.STOP_FAILED) && instance?.deploymentClass !== DeploymentClass.E"
                    [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING) : (instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING), 'background-color-opacity': !permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]}"
                    class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600 flex items-center"
                  	type="button" [matMenuTriggerFor]="(permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] ? blueprintVersionMenu : '')">
                    	{{'BUTTONS.UPDATE' | transloco}}<mat-icon svgIcon="expand_more" class="flex justify-end icon-sm ml-8"></mat-icon>
                 </button>
				 <div *ngIf="!permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII]" class="add-lock flex red">
					<mat-icon *ngIf="instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
					instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED" svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
				</div>
				 <mat-menu #blueprintVersionMenu [xPosition]="'before'" class="context-menu-dropdown">
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
						(click)="updateBuild(instance)">
						<div class="fw-500 menu-button">
						{{'INSTANCE_DETAILS.SOLUTION_UPGRADE' | transloco}}
						</div>
					</button>
					@if(permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] && instance?.type !== 'tsi' && instance?.type !== 'tss') {
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': (instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING), 'disable-infra': !instance?.isInfraUpgrade }" 
						(click)="instance?.isInfraUpgrade ? infraUpgradeClick(instance) : ''"
						[disabled]="!instance?.isInfraUpgrade"
						matTooltipClass="left infra-tooltip" matTooltipPosition="left" [matTooltip]="instance?.isInfraUpgrade ? '' : ('INSTANCE_DETAILS.INFRA_UPGRADE_DISABLE' | transloco)">
						<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.INFRA_UPGRADE' | transloco}}
						</div>
					</button>
					}
					<button class="flex justify-start items-center action-button h-40 pl-16"
					[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="packageUpdate(instance)">
						<div class="fw-500 menu-button">
						{{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco}}
						</div>
					</button>
					@if(showComponentUpdate) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="componentUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.COMPONENT_UPDATE' | transloco}}
							</div>
						</button>
					}
					@if(canAccessBaseImageFeature(instance?.id)) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.status === DeployStatus.UPDATING }" (click)="baseImageUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.BASE_IMAGE' | transloco}}
							</div>
						</button>
					}
				  </mat-menu>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

	<div *ngIf="piiNonPTLInstances?.length > 0" class="mat-subtitle-1 fs-10 fw-700 test-zone mb-0 pl-16 pii-zone">{{'TENANT_CONTINUOUS_UPDATE.PII_DATA_ZONE' | transloco | uppercase}}</div>
    <div class="view-instances mb-32">
		<div class="tbl tbl-shared-instances w-100-percent">
			<div  *ngIf="piiNonPTLInstances?.length > 0 && devInstance?.length === 0" class="tbl-header-row primary mb-8 fw-700 fs-14 mat-subtitle-2">
				<div class="tbl-cell col-instance-name pl-12">{{ 'INSTANCE_DETAILS.INSTANCE_NAME' | transloco | uppercase}}</div>
				<div class="tbl-cell col-primary">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco | uppercase }}</div>
				<div class="tbl-cell col-class cursor-pointer">
				  {{ 'INSTANCE_DETAILS.RELEASE_VERSION' | transloco | uppercase }}
				</div>
				<div class="tbl-cell col-infra cursor-pointer">
				  {{ 'INSTANCE_DETAILS.INFRA_VERSION' | transloco | uppercase }}
				</div>
                <div class="tbl-cell col-secondary cursor-pointer">
                  {{ 'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco | uppercase }}
                </div>
				<div class="tbl-cell col-status cursor-pointer">
				  {{ 'INSTANCE_DETAILS.STATUS' | transloco | uppercase }}
				</div>
				<div class="tbl-cell col-action items-center">{{ 'INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_BUILD' | transloco | uppercase }}</div>
			  </div>
        <div class="tbl-body">
          <div *ngFor="let instance of piiNonPTLInstances" class="mb-8">
            <ng-container *ngIf="instance?.id">
              <div class="tbl-body-row tbl-high-row fw-400 fs-16 mat-subtitle-2" [ngClass]="{'apply-opacity' : !((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE]))}">
                <div *ngIf="((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE])); else showUnauthorized" class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border" (click)="openInstanceDetails(instance)">
                  <span class="cell-data instance-name fw-500 clickable" [title]="instance?.name">{{instance?.name}}</span>
                  <mat-icon *ngIf="instance?.name === 'Demo Instance'" svgIcon="info" class="icon-md-1 pl-8 icon"
                  matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
                </div>
				<ng-template #showUnauthorized>
					<div class="tbl-cell col-instance-name pl-12 flex justify-start items-center cursor-pointer border remove-opacity">
						<span class="flex flex-row cell-data instance-name fw-500 red">
							<mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon"></mat-icon>
							{{ 'INSTANCE_DETAILS.UNAUTHORIZED' | transloco }}</span>
					</div>
				</ng-template>

                <div class="tbl-cell col-primary cell-data border fs-14 fw-500" [title]="instance?.dataZone">
                  {{ instance?.dataZone | titlecase }}
                </div>
                <div class="tbl-cell col-class border mat-body-1 flex items-center" [title]="instance?.releaseVersion ? instance?.releaseVersion : '-'">
                  {{ instance?.releaseVersion ? instance?.releaseVersion : '-' }}
				  <div *ngIf="solutionVersionsService.releaseVersion(instance?.releaseVersion)" class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">
					{{('INSTANCE_DETAILS.AMR' | transloco)}}
				  </div>
                </div>
				 <div class="tbl-cell col-infra border mat-body-1 flex items-center" [title]="instance?.infraSolutionVersion">
                  {{ instance?.infraSolutionVersion ? instance?.infraSolutionVersion : '-' }}
                </div>
                <div class="tbl-cell col-secondary flex items-center border mat-body-1">
                    <span [title]="instance?.externalPackage?.name ? instance?.externalPackage?.name : '-'" class="custom-package">{{ instance?.externalPackage?.name ? instance?.externalPackage?.name : '-' }}</span>
                    <span *ngIf="instance?.externalPackage?.name" (click)="customPackageClick(instance)"><mat-icon svgIcon="info" class="icon-sm ml-4 cursor-pointer"></mat-icon></span>
                </div>
                <div class="tbl-cell col-status border mat-body-1" [title]="instance?.status">
                    <span [ngClass]="{'failed': failedStatus.includes(instance?.status),
                      'updated': updatedStatus.includes(instance?.status),
                      'pending': pendingStatus.includes(instance?.status),
                      'in-progress': inProgressStatus.includes(instance?.status)}"
                      class="pt-4 pr-8 pb-4 pl-8 flex">
					  <mat-icon *ngIf="statusIcons[instance?.status]" [svgIcon]="statusIcons[instance?.status]" class="icon-sm mr-4 mt-4" [ngClass]="instance?.status === DeployStatus.DEPLOYED || instance?.status === DeployStatus.UPDATED ? 'sucess-circle': 'failed-circle'"></mat-icon>
					{{formatAvailabilityState(instance?.status) | titlecase}}
                      <mat-progress-bar *ngIf="instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.DEPLOYING" class="progress-bar" mode="indeterminate"></mat-progress-bar>
                    </span>
                </div>
                <div class="tbl-cell col-action" [ngClass]="{'apply-opacity' : !((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE]))}">
                  <button *ngIf="(instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
                  	instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED || instance?.status === DeployStatus.STOP_FAILED) && instance?.deploymentClass !== DeploymentClass.E"
                    [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING) : (instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.CONFIGURING), 'background-color-opacity': !((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE])) }"
					class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600 flex items-center"
					type="button" [matMenuTriggerFor]="(((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE])) ? blueprintVersionMenu : '')">
						{{'BUTTONS.UPDATE' | transloco}}<mat-icon svgIcon="expand_more" class="flex justify-end icon-sm ml-8"></mat-icon>
				 </button>
				 <div *ngIf="!((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) || (instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE]))" class="add-lock flex red">
					<mat-icon *ngIf="instance?.status === DeployStatus.FAILED || instance?.status === DeployStatus.UPDATED || instance?.status === DeployStatus.DEPLOYED ||
					instance?.status === DeployStatus.CONFIGURING || instance?.status === DeployStatus.CONFIGURED || instance?.status === DeployStatus.UPDATING || instance?.status === DeployStatus.CONFIGURATION_FAILED || instance?.status === DeployStatus.TEST_FAILED || instance?.status === DeployStatus.TESTED || instance?.status === DeployStatus.UPDATE_FAILED" svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
				</div>
				  <mat-menu #blueprintVersionMenu [xPosition]="'before'" class="context-menu-dropdown">
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }"
						(click)="updateBuild(instance)">
						<div class="fw-500 menu-button">
						{{'INSTANCE_DETAILS.SOLUTION_UPGRADE' | transloco}}
						</div>
					</button>
					@if(((instance?.dataZone === DataZone.SECURE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII]) ||
					(instance?.dataZone === DataZone.LIVE && permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE])) && instance?.type !== 'tsi' && instance?.type !== 'tss') {
					<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': (instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING), 'disable-infra': !instance?.isInfraUpgrade }"
              			(click)="instance?.isInfraUpgrade ? infraUpgradeClick(instance) : ''"
						[disabled]="!instance?.isInfraUpgrade"
						matTooltipClass="left infra-tooltip" matTooltipPosition="left" [matTooltip]="instance?.isInfraUpgrade ? '' : ('INSTANCE_DETAILS.INFRA_UPGRADE_DISABLE' | transloco)">
						<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.INFRA_UPGRADE' | transloco}}
						</div>
					</button>
					}
					<button class="flex justify-start items-center action-button h-40 pl-16"
					[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="packageUpdate(instance)">
						<div class="fw-500 menu-button">
						{{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco}}
						</div>
					</button>
					@if(showComponentUpdate) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== 'running' || instance?.status === DeployStatus.UPDATING) : instance?.status === DeployStatus.UPDATING }" (click)="componentUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.COMPONENT_UPDATE' | transloco}}
							</div>
						</button>
					}
					@if(canAccessBaseImageFeature(instance?.id)) {
						<button class="flex justify-start items-center action-button h-40 pl-16"
						[ngClass]="{'disabled': instance?.status === DeployStatus.UPDATING }" (click)="baseImageUpdate(instance)">
							<div class="fw-500 menu-button">
							{{'INSTANCE_DETAILS.BASE_IMAGE' | transloco}}
							</div>
						</button>
					}
				  </mat-menu>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
	</div>

    <div *ngIf="devInstance?.length === 0 && testDataZoneInstances?.length === 0 && piiDataZoneInstances?.length === 0 && piiNonPTLInstances?.length === 0 && nonPiiNonPTLInstances?.length === 0 && classEInstances?.length === 0" class="flex flex-col items-center fw-600 fs-20 justify-center pt-48 pb-48">
		<img src="/assets/images/unavailable-instance.png">
		{{'INSTANCE_LIST.INSTANCE_UNAVAILABLE' | transloco }}
    </div>
	</div>

	<div *ngIf="transientEnvironmentComponent" class="ml-24 fw-600 fs-22 mb-0">{{'INSTANCE_DETAILS.TRANSIENT_INSTANCES' | transloco}}</div>
	<div class="flex flex-row justify-between">
		<div *ngIf="transientEnvironmentComponent" class="flex flex-row pl-26 pt-26 transient-environment-width">
			<div class="flex flex-col check-width-first">
				<mat-icon [svgIcon]="deployed ? 'check_circle' : 'circle'" class="icon-lg ml-12" [ngClass]="deployed ? 'check-circle' : 'circle'"></mat-icon>
				<span>{{deployed ? ('INSTANCE_DETAILS.TRANSIENT_DEPLOYED' | transloco) : ('INSTANCE_DETAILS.TRANSIENT_DEPLOY' | transloco)}}</span>
			</div>
			<div class="p-40 progress-line"></div>
			<div class="flex flex-col check-width">
				<mat-icon [svgIcon]="configured ? 'check_circle' : 'circle'" class="icon-lg" [ngClass]="configured ? 'check-circle' : 'circle'"></mat-icon>
				<span>{{configured ? ('INSTANCE_DETAILS.TRANSIENT_CONFIGURED' | transloco) : ('INSTANCE_DETAILS.TRANSIENT_CONFIGURE' | transloco)}}</span>
			</div>
			<div class="p-40 progress-line"></div>
			<div class="flex flex-col check-width">
				<mat-icon [svgIcon]="updated ? 'check_circle' : 'circle'" class="icon-lg" [ngClass]="updated ? 'check-circle' : 'circle'"></mat-icon>
				<span>{{updated ? ('INSTANCE_DETAILS.TRANSIENT_UPDATED' | transloco) : ('INSTANCE_DETAILS.TRANSIENT_UPDATE' | transloco)}}</span>
			</div>
			<div class="p-40 progress-line"></div>
			<div class="flex flex-col check-width">
				<mat-icon [svgIcon]="tested ? 'check_circle' : 'circle'" class="icon-lg" [ngClass]="tested ? 'check-circle' : 'circle'"></mat-icon>
				<span>{{tested ? ('INSTANCE_DETAILS.TRANSIENT_TESTED' | transloco) : ('INSTANCE_DETAILS.TRANSIENT_TEST' | transloco)}}</span>
			</div>
		</div>
		<div *ngIf="transientEnvironmentComponent" class="flex flex-col">
			<button class="btn-link mat-headline-6 fw-700 flex justify-end items-center m-24"
				(click)="refreshTransientInstance();">
				<mat-icon svgIcon="refresh" class="mr-12" [@rotate]="count"
				(@rotate.done)="isLoading && count=count+1"></mat-icon>
				{{'INSTANCE_DETAILS.REFRESH_INSTANCE' | transloco}}
			</button>
		</div>
	</div>
	<div *ngIf="transientEnvironmentComponent" class="flex flex-col border-radius transient-environment m-24 p-16">
		<table mat-table [dataSource]="transientDataSource" class="mat-elevation">
		  <ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef class="pt-12 pb-12 fs-14 fw-700"> {{'INSTANCE_DETAILS.INSTANCE_NAME' | transloco | uppercase}}</th>
			<td mat-cell *matCellDef="let data" class="cursor-pointer border">
			  <div class="flex justify-start items-center">
				<span class="cell-data instance-name" [title]="data.name">{{data.name}}</span>
			  </div>
			</td>
		  </ng-container>
		  <ng-container matColumnDef="dataZone">
			<th mat-header-cell *matHeaderCellDef class="pt-12 pb-12 fs-14 fw-700"> {{'INSTANCE_DETAILS.ENVIRONMENT' | transloco | uppercase}} </th>
			<td mat-cell *matCellDef="let data" class="cell-data border" [title]="data.dataZone"> <div>{{data.dataZone | titlecase}} </div></td>
		  </ng-container>

		  <ng-container matColumnDef="version">
			<th mat-header-cell *matHeaderCellDef class="pt-12 pb-12 fs-14 fw-700"> {{'INSTANCE_DETAILS.BUILD_VERSION' | transloco | uppercase}} </th>
			<td mat-cell *matCellDef="let data" class="border"><div> {{data.version ? data.version : '-'}} </div> </td>
		  </ng-container>

		  <ng-container matColumnDef="rvtStatus">
			<th mat-header-cell *matHeaderCellDef class="pt-12 pb-12 fs-14 fw-700"> {{'INSTANCE_DETAILS.STATUS' | transloco | uppercase}} </th>
			<td mat-cell *matCellDef="let data" class="cell-data border status" [title]="data.rvtStatus">
				<div>
					<span class="pl-4 pr-4" [ngClass]="{'failed': data.rvtStatus === DeployStatus.FAILED || data.rvtStatus === DeployStatus.UPDATED_FAILED || data.rvtStatus === DeployStatus.CONFIGURATION_FAILED || data.rvtStatus === DeployStatus.TERMINATED || data.rvtStatus === false,
					'updated': data.rvtStatus === DeployStatus.UPDATED || data.rvtStatus === DeployStatus.DEPLOYED || data.rvtStatus === DeployStatus.TESTED || data.rvtStatus === true,
					'pending': data.rvtStatus === DeployStatus.CONFIGURING || data.rvtStatus === DeployStatus.CONFIGURED,
					'in-progress': data.rvtStatus === DeployStatus.UPDATING || data.rvtStatus === DeployStatus.DEPLOYING}"> {{data.rvtStatus === true ? 'Success' : (data.rvtStatus === false ? 'Failed' : data.rvtStatus | titlecase)}}
					<mat-progress-bar *ngIf="data?.rvtStatus === DeployStatus.UPDATING || data.rvtStatus === DeployStatus.DEPLOYING" class="progress-bar" mode="indeterminate"></mat-progress-bar>
					</span>
				</div>
			</td>
		  </ng-container>

		  <!-- <ng-container matColumnDef="action">
			<th mat-header-cell *matHeaderCellDef class="pt-12 pb-12 fs-14 fw-700"> {{'INSTANCE_DETAILS.ACTION' | transloco | uppercase}} </th>
			<td mat-cell *matCellDef="let data" class="cell-data border">
				<div>
					<button *ngIf="(deployed ||status === DeployStatus.DEPLOYING) && (!configured && status !== DeployStatus.CONFIGURING) && (!updated && status !== DeployStatus.UPDATING) && (!tested && status !== DeployStatus.TESTING) && status !== DeployStatus.TERMINATED"
							class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600"
							[ngClass]="{'disabled': status !== DeployStatus.DEPLOYED && status !== DeployStatus.CONFIGURED && status !== DeployStatus.UPDATED && status !==  DeployStatus.TESTED}"
							type="button" (click)="configureTesting()">
								{{'BUTTONS.APPLY_CONFIGURATION' | transloco}}
					</button>
					<button *ngIf="deployed && (configured || status === DeployStatus.CONFIGURING) && (!updated && status !== DeployStatus.UPDATING) && (!tested && status !== DeployStatus.TESTING) && status !== DeployStatus.TERMINATED"
							class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600"
							[ngClass]="{'disabled': status !== DeployStatus.DEPLOYED && status !== DeployStatus.CONFIGURED && status !== DeployStatus.UPDATED && status !==  DeployStatus.TESTED}"
							type="button" (click)="updateTesting()">
								{{'BUTTONS.UPDATE' | transloco}}
					</button>
					<button *ngIf="deployed && configured && (updated || status === DeployStatus.UPDATING) && (!tested && status !== DeployStatus.TESTING) && status !== DeployStatus.TERMINATED"
							class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600"
							[ngClass]="{'disabled': status !== DeployStatus.DEPLOYED && status !== DeployStatus.CONFIGURED && status !== DeployStatus.UPDATED && status !==  DeployStatus.TESTED}"
							type="button" (click)="rvtTesting()">
								{{'BUTTONS.RUN_TEST' | transloco}}
					</button>
					<button *ngIf="deployed && configured && updated && tested && status !== DeployStatus.TERMINATED"
							class="accent pt-4 pr-12 pb-4 pl-12 h-auto fw-600"
							type="button" (click)="terminateInstance()">
								{{'BUTTONS.TERMINATE' | transloco}}
					</button>
					<button *ngIf="status === DeployStatus.TERMINATED"
							class="pt-4 pr-12 pb-4 pl-12 h-auto fw-600"
							type="button">
							{{'BUTTONS.NOT_AVAILABLE' | transloco}}
					</button>
				</div>
			</td>
		  </ng-container> -->

		  <ng-container matColumnDef="menu">
			<th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
			<td mat-cell *matCellDef="let data" class="cell-data border">
				<div>
					<button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8"
						[matMenuTriggerFor]="instanceSubmenu">
						<mat-icon svgIcon="more_vert"></mat-icon>
					</button>
				</div>
				<mat-menu #instanceSubmenu [xPosition]="'before'" class="context-menu-dropdown">
					<div class="flex flex-col">
						<button [ngClass]="{'disabled': status === DeployStatus.TERMINATED }" class="menu-button" (click)="terminateInstance()">
							<div class="flex flex-row justify-start items-center terminate">
							<mat-icon svgIcon="delete" class="icon-md terminate"></mat-icon>
							<div class="mat-body fw-400">{{'BUTTONS.TERMINATE' | transloco }}</div>
							</div>
						</button>
					</div>
				</mat-menu>
			</td>
		  </ng-container>
		  <tr mat-header-row *matHeaderRowDef="transientColumns"></tr>
		  <tr mat-row *matRowDef="let row; columns: transientColumns;"></tr>
		</table>
		<div class="flex flex-col border-radius mat-elevation mt-24" *ngIf="configured || tested">
			<mat-tab-group animationDuration="0ms">
				<mat-tab *ngIf="configured">
					<ng-template mat-tab-label>
						<span>{{'INSTANCE_DETAILS.CONFIG_RESULTS' | transloco }}{{'('+ configResponse.length +')'}}</span>
					</ng-template>
					<div class="flex justify-end mb-12">
						<app-search-filter (keyup)="searchResultsConfig($event)"></app-search-filter>
					</div>
					<div class="tbl tbl-border tbl-configuration-package">
						<div class="tbl-header-row secondary">
						  <div class="fs-12 fw-700 tbl-cell col-filename">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco  }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco  }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
						</div>
						<div class="tbl-body">
						  <ng-container *ngIf="configResponsePagination?.length > 0; else noDataFound">
							<div *ngFor="let configurationPackage of configResponsePagination" class="tbl-body-row">
							  <div class="tbl-cell col-filename">{{ configurationPackage.name }}</div>
							  <div class="tbl-cell col-start-time">
								{{ (configurationPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
							  </div>
							  <div class="tbl-cell col-end-time">
								{{ (configurationPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
							  </div>
							  <div class="tbl-cell col-duration">
								{{ configurationPackage.startDate | duration : configurationPackage.endDate : '-' }}
							  </div>
							  <div class="tbl-cell col-status" [ngClass]="{
								'green-1-fg' : configurationPackage.status === 'true',
								'warn-solid-fg': configurationPackage.status === 'failed',
								'neutral-blue-4-fg': !configurationPackage.status
							  }">{{ (configurationPackage.status | titlecase) || '-' }}</div>
							</div>
						  </ng-container>
						<app-paginator [length]="configResponse.length" [pageSizeOptions]="[10, 15, 20]"
							  [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChangedConfig($event)"></app-paginator>
						  <ng-template #noDataFound>
							<div class="ta-center">{{ 'CONFIGURATIONS.NO_DATA_FOUND' | transloco }}</div>
						  </ng-template>
						</div>
					  </div>
				</mat-tab>
				<mat-tab *ngIf="tested">
					<ng-template mat-tab-label>
					<span>{{'INSTANCE_DETAILS.TEST_RESULTS' | transloco }}{{'('+ testResponse?.transientTest?.configResult?.overview?.packages.length +')'}}</span>
					</ng-template>
					<div class="flex justify-end mb-12">
						<app-search-filter (keyup)="searchResultsTest($event)"></app-search-filter>
					</div>
					<div class="tbl tbl-border tbl-test-package">
						<div class="tbl-header-row secondary">
						  <div class="fs-12 fw-700 tbl-cell col-filename">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FILENAME' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-start-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-end-time">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-duration">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-success">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.SUCCESS' | transloco }}</div>
						  <div class="fs-12 fw-700 tbl-cell col-failure">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.FAILURE' | transloco }}</div>
						  <!-- <div class="tbl-cell col-download-results"></div>
						  <div class="tbl-cell col-view-results"></div> -->
						</div>
						<div class="tbl-body">
						  <ng-container *ngIf="testResponsePagination?.length > 0; else noDataFound">
							<div *ngFor="let testPackage of testResponsePagination" class="tbl-body-row">
							  <div class="tbl-cell col-filename">{{ testPackage.name }}</div>
							  <div class="tbl-cell col-start-time">
								{{ (testPackage.startDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
							  </div>
							  <div class="tbl-cell col-end-time">
								{{ (testPackage.endDate | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) || '-' }}
							  </div>
							  <div class="tbl-cell col-duration">
								{{ testPackage.startDate | duration : testPackage.endDate : '-' }}
							  </div>
							  <div class="tbl-cell col-status" [ngClass]="{
								'green-1-fg' : testPackage.status === true,
								'warn-solid-fg': testPackage.status === false,
								'neutral-blue-4-fg': !testPackage.status
							  }">
								{{ testPackage.status || ('CONFIGURATIONS.VIEW_RESULTS.NOT_EXECUTED' | transloco) }}
							  </div>
							  <div class="tbl-cell col-success">{{ testPackage.success !== null ?  testPackage.success : '-' }}</div>
							  <div class="tbl-cell col-failure">{{ testPackage.failure !== null ?  testPackage.failure : '-' }}</div>
							  <!-- <div class="tbl-cell col-download-results">
								<mat-icon class="cursor-pointer" svgIcon="file_download" (click)="downloadTestResults(testResponse, testPackage.resultsReportFile)"></mat-icon>
							  </div>
							  <div class="tbl-cell col-view-results">
								<mat-icon class="cursor-pointer" svgIcon="visibility" (click)="viewTestResults(testResponse, testPackage.resultsReportFile)"></mat-icon>
							  </div> -->
							</div>
						  </ng-container>
						  <app-paginator [length]="testResponse?.transientTest?.testResult?.overview?.packages?.length" [pageSizeOptions]="[10, 15, 20]"
							  [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChangedTest($event)"></app-paginator>
						  <ng-template #noDataFound>
							<div class="ta-center">{{ 'CONFIGURATIONS.NO_DATA_FOUND' | transloco }}</div>
						  </ng-template>
						</div>
					  </div>
				</mat-tab>
			</mat-tab-group>
		</div>
		<mat-card *ngIf="showSpinner" class="flex spinner-container spinner p-24">
			<mat-spinner diameter="24"
			  color="primary"
			  mode="indeterminate">
			</mat-spinner>
		</mat-card>
	</div>

</div>
